import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import HomePage from "@/pages/HomePage";
import GameDetailPage from "@/pages/GameDetailPage";
import AboutPage from "@/pages/AboutPage";
import SubmitGamePage from "@/pages/SubmitGamePage";
import CrowdfundingPage from "@/pages/CrowdfundingPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminAnalytics from "@/pages/AdminAnalytics";
import BannerPage from "@/pages/BannerPage";
import Layout from "@/components/Layout";

function App() {
  return (
    <>
      <div className="grain-overlay" aria-hidden="true"></div>
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/game/:id" element={<GameDetailPage />} />
            <Route path="/crowdfunding" element={<CrowdfundingPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/submit-game" element={<SubmitGamePage />} />
          </Route>
          <Route path="/admin" element={<AdminLoginPage />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/analytics" element={<AdminAnalytics />} />
          <Route path="/banner" element={<BannerPage />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
